module.exports = __webpack_public_path__ + "media/images/google-logo-68587878f65bc4132aafbaa744caf653.svg";